<template>
  <div class="t-invite">
    <h2>{{ invite.title }}</h2>
    <form @submit.stop.prevent="Submit()">

      <cmp-calendar v-if="openCalendar" @selectDate="selectDate" :select="nextLesson"></cmp-calendar>

      <v-bar wrapper="t-invite__time" v-if="lessonsArr.length">
        <div class="t-invite-time__wrapper">
          <div class="t-invite-time__item" v-for="(item, index) in lessonsArr" :key="'time_' + index" @click.prevent="SetDate(item)">
            {{ item.time }}
          </div>
        </div>
      </v-bar>

      <div class="t-input" v-if="nextLesson.date_time">
        <label>{{ date }}</label>
        <p>{{ time }}</p>
        <span class="t-invite__updateDate" @click.prevent="openCalendar = true">{{ invite.dateBtn }}</span>
      </div>
      <div class="t-input" v-for="(item, index) in form" :key="index" :class="{_error: item.error}">
        <label>{{ item.label }}</label>

        <textarea v-if="item.type === 'textarea'" v-model="item.value" :placeholder="item.placeholder" @focus="Focus(index)"></textarea>
        <template v-else>
          <input v-model="item.value" :type="item.type" :placeholder="item.placeholder" @focus="Focus(index)">
          <p class="t-callBack__hint">{{ invite.emailHint }}</p>
        </template>
      </div>
      <!-- <div class="t-input">
        <input type="checkbox" id="personal_info" class="t-checkbox" v-model="personalInfo">
        <label for="personal_info">
          {{ invite.personalData_1 }}
          <a href="#" download rel="nofollow">{{ invite.personalData_2 }}</a>
          {{ invite.personalData_3 }}
          <a href="#" download rel="nofollow">{{ invite.personalData_4 }}</a>
        </label>
      </div>
      <button class="t-btn" :class="{_disabled: disabledBtn}"><span>{{ invite.btn }}</span></button> -->
      <button class="t-btn"><span>{{ invite.btn }}</span></button>

    </form>
  </div>
</template>

<script>
    import VBar from 'v-bar'

    import {store} from '../../store'

    import {mapGetters} from 'vuex';
    import {mapActions} from 'vuex';

    import Calendar from '../Calendar_modal/Calendar.vue'

    export default {
        components: {
            'cmp-calendar': Calendar,
            VBar
        },
        data(){
            return{
                nextLesson: {},

                lessonsArr: [],

                openCalendar: false,

                // disabledBtn: false,
                action: 'invite',
                form: [
                    {
                        label: store.getters['staticText/invite'].emailTitle,
                        name: 'email',
                        type: 'email',
                        value: '',
                        placeholder: '',
                        error: false,
                        pattern: /^[^@]{2,}@[^@.]{2,}\.[^@]{2,}$/
                    }
                ],
                // personalInfo: false
            }
        },
        computed: {
            ...mapGetters(['mobile']),
            ...mapGetters('staticText', ['invite']),
            ...mapGetters('coursesList', ['course']),
            ...mapGetters('calendar', ['calendarText']),
            date(){
                if(this.nextLesson.date_time){
                    let date = new Date(this.nextLesson.date_time);

                    return date.getDate() + ' ' + this.calendarText.month_2[date.getMonth()];
                }
            },
            time(){
                if(this.nextLesson.date_time) {
                    let time = '';

                    let date = new Date(this.nextLesson.date_time);

                    let hours = date.getHours();
                    let minutes = date.getMinutes();

                    let time_start = [];
                    time_start.push(hours < 10 ? '0' + hours : hours);
                    time_start.push(minutes < 10 ? '0' + minutes : minutes);

                    time += time_start.join(':');

                    minutes = (hours * 60) + minutes + this.nextLesson.duration;
                    hours = Math.floor(minutes / 60);
                    minutes = minutes - hours * 60;
                    if (hours < 10)
                        hours = '0' + hours;
                    if (minutes < 10)
                        minutes = '0' + minutes;
                    return time += '-' + hours + ':' + minutes;
                }
            }
        },
        methods: {
            ...mapActions('modal', ['modalDialogClose']),
            ...mapActions('msg', ['showMsg']),
            SetDate(item){
                this.nextLesson = item;
                this.lessonsArr = [];
            },
            selectDate(lessons){
                if(lessons.length > 1){
                    for(let i = 0; i < lessons.length; i++){
                        let time = '';

                        let date = new Date(lessons[i].date_time);

                        let hours = date.getHours();
                        let minutes = date.getMinutes();

                        let time_start = [];
                        time_start.push(hours < 10 ? '0' + hours : hours);
                        time_start.push(minutes < 10 ? '0' + minutes : minutes);

                        time += time_start.join(':');

                        minutes = (hours * 60) + minutes + lessons[i].duration;
                        hours = Math.floor(minutes / 60);
                        minutes = minutes - hours * 60;
                        if (hours < 10)
                            hours = '0' + hours;
                        if (minutes < 10)
                            minutes = '0' + minutes;
                        time += '-' + hours + ':' + minutes;

                        lessons[i].time = time;

                        this.lessonsArr.push(lessons[i])
                    }
                    this.openCalendar = false;
                } else{
                    this.nextLesson = lessons[0];
                    this.openCalendar = false;
                }
            },
            Submit(){
                // this.disabledBtn = true;

                let is_valid = true;

                for(let i = 0; i < this.form.length; i++){
                    if(this.form[i].pattern !== '') {
                        if (!this.form[i].pattern.test(this.form[i].value)) {
                            this.form[i].error = true;
                            is_valid = false;
                        }
                    } else{
                        if (this.form[i].value === '') {
                            this.form[i].error = true;
                            is_valid = false;
                        }
                    }
                }

                // if(!this.personalInfo){
                //     is_valid = false;
                //     this.disabledBtn = false;
                // }

                if(is_valid){
                    let fd = new FormData();

                    for(let i = 0; i < this.form.length; i++){
                        fd.append(this.form[i].name, this.form[i].value)
                    }

                    if(this.nextLesson)
                        fd.append('id', this.nextLesson.id);

                    fd.append('courseId', this.$route.params.id);

                    this.$http.post(this.action, fd)
                        .then(response => {
                            this.modalDialogClose();
                            this.showMsg(this.invite.msgSuccess)
                        }, response => {
                            this.modalDialogClose();
                            this.showMsg('Упс, что-то пошло не так, попробуйте позже')
                        });
                }
            },
            Focus(i){
                this.form[i].error = false
            }
        },
        mounted(){
            this.nextLesson = this.course.nextLesson;
        }
    }
</script>

<style lang="sass">
.t-invite
  width: 320px
  margin: 0 auto
  @extend %blueBorderBox
  &__updateDate
    color: $blue
    font-size: 14px
    cursor: pointer
    @media (min-width: 770px)
      &:hover
        text-decoration: underline
  .t-calendar
    position: absolute
    top: 10px
    left: 8px
    right: 8px
    margin: 0
    z-index: 3
  &__time
    z-index: 3
    position: absolute
    top: 10px
    left: 8px
    right: 8px
    max-height: 383px
    background: #FFFFFF
    box-shadow: 0 24px 32px rgba(0, 108, 202, 0.1)
    border-radius: 16px
    list-style-type: none
    .bar--vertical
      width: 1px
      background: $disabled
      height: calc(100% - 32px)
      margin-top: 16px
      margin-right: 16px
    .bar--vertical-internal
      background: $blue
    .bar--container
      max-height: 383px
    .bar--wrapper
      position: relative
      height: 100%
      max-height: 407px
      > *
        padding-right: 53px!important
.t-invite-time
  padding: 8px 0
  &__item
    padding: 8px 16px
    transition: all .2s
    cursor: pointer
    @media(min-width: 769px)
      &:hover
        background: $blue
        color: #ffffff
</style>


// WEBPACK FOOTER //
// src/vue_components/ModalDialog/Invite.vue